import React from 'react';
import Popover from '@teetsh/app/src/components/Popover';
import 'twin.macro';
import { css } from '@emotion/react';
import { bgColors } from '@teetsh/app/src/components/colors';
import { Color } from '@teetsh/app/src/types/colors';
import {
  ColorsList,
  Option,
} from '@teetsh/app/src/components/Form/Colorpicker/ColorsList';
import usePopoverContext from 'components/Popover/usePopoverContext';
import { BaseButtonProps } from 'components/Buttons/BaseButtonProps';
import { ColorsListDualPalette } from './ColorsListDualPalette';
import { ColorPaletteConfig } from 'containers/App/context/useColorPalette';

interface Props extends BaseButtonProps {
  children?: React.ReactNode;
  portal?: boolean;
  className?: string;
}

interface PanelProps {
  value: string;
  onChange: (v: Color) => void;
  options?: Option[];
  colorPalette: ColorPaletteConfig;
}

function Panel(props: PanelProps) {
  const { onChange, options, value, colorPalette } = props;
  const { refs } = usePopoverContext();

  if (options) {
    return (
      <div tw="m-2">
        <ColorsList
          value={value}
          onChange={v => {
            onChange(v);
            if (refs?.reference?.current) {
              (refs?.reference?.current as any).click();
            }
          }}
          options={options}
        />
      </div>
    );
  }

  return (
    <ColorsListDualPalette
      value={value}
      onChange={v => {
        onChange(v);
        if (refs?.reference?.current) {
          (refs?.reference?.current as any).click();
        }
      }}
      options={options}
      colorPalette={colorPalette}
      tw="m-6"
    />
  );
}

export function ColorPicker(props: Props & PanelProps) {
  const {
    value,
    onChange,
    options,
    portal,
    children,
    colorPalette,
    ...buttonProps
  } = props;
  const color = value === undefined || value === '' ? 'blue' : value;

  return (
    <Popover portal={portal === undefined ? true : portal}>
      <Popover.Button
        css={[
          bgColors(color as Color),
          css`
            &:hover,
            &:active,
            &:focus {
              ${bgColors(color as Color)};
              opacity: 80%;
            }
          `,
        ]}
        {...buttonProps}
      >
        {children}
      </Popover.Button>
      <Popover.Panel size="auto">
        <Panel
          value={value}
          onChange={onChange}
          options={options}
          colorPalette={colorPalette}
        />
      </Popover.Panel>
    </Popover>
  );
}
